/**
 * Client-side validation for free-text reporting requirement values against a stored regex pattern.
 * Keep patterns compatible with both JavaScript and .NET regex engines.
 */
export const errorMessage = 'Value must match the configured format for this reporting requirement.';

/** When value validation is disabled in CRM, never apply regex. Undefined = treat as enabled (back-compat). */
export function getEffectiveReportingValueValidationPattern(model: {
  ValueValidationEnabled?: boolean | null;
  valueValidationEnabled?: boolean | null;
  ValueValidationPattern?: string | null;
  valueValidationPattern?: string | null;
}): string | null {
  const enabled = model.ValueValidationEnabled ?? model.valueValidationEnabled;
  if (enabled === false) {
    return null;
  }
  return model.ValueValidationPattern ?? model.valueValidationPattern ?? null;
}

/** Non-empty example strings from company CRM, in display order. */
export function getValueValidationExampleStrings(model: {
  ValueValidationExamples?: string[] | null;
  valueValidationExamples?: string[] | null;
}): string[] {
  const raw = model.ValueValidationExamples ?? model.valueValidationExamples;
  if (!raw?.length) {
    return [];
  }
  return raw.map((s) => String(s).trim()).filter((s) => s.length > 0);
}

/** Returns `undefined` when valid; an error message string when invalid. */
export function getReportingValueRegexError(
  value: string | undefined,
  pattern: string | null | undefined
): string | undefined {
  if (pattern == null || String(pattern).trim() === '') {
    return undefined;
  }
  if (value == null || value === '') {
    return undefined;
  }
  try {
    const re = new RegExp(pattern);
    return re.test(value) ? undefined : errorMessage;
  } catch {
    return 'The validation pattern for this requirement is invalid. Contact support or update it in company CRM.';
  }
}
